import styled from 'styled-components/macro';
import InfoItem from './components/InfoItem';

export const Container = styled.div`
  width: 100%;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.white};
  padding: 20px;
  align-items: center;
  justify-content: center;
`;
export const Content = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.blue};
  justify-content: center;
`;

export const InfoList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
  grid-row-gap: 15px;
  grid-template-areas:
    'ROUND .'
    'DATE WEATHER'
    'TIME HUMIDITY'
    'TIME TEMPERATURE'
    'STADIUM STADIUM';
  max-width: 332px;
  padding: 30px 10px;
  width: 100%;
`;

export const LogoContainer = styled.div``;

export const Logo = styled.div`
  width: 200px;
  height: 27px;
  background: url(${({ url }) => url}) no-repeat center;
  background-size: cover;
  filter: invert(1);
`;

export const LogoDefault = styled.img`
  width: 151px;
`;

export const ScoreContainer = styled.div`
  padding: 34px 0px;
`;

export const InfoItemRound = styled(InfoItem)`
  grid-area: ROUND;
`;
export const InfoItemDate = styled(InfoItem)`
  grid-area: DATE;
`;
export const InfoItemTime = styled(InfoItem)`
  grid-area: TIME;
`;
export const InfoItemStadium = styled(InfoItem)`
  grid-area: STADIUM;
`;
export const InfoItemWeather = styled(InfoItem)`
  grid-area: WEATHER;
`;
export const InfoItemHumidity = styled(InfoItem)`
  grid-area: HUMIDITY;
`;
export const InfoItemTemperature = styled(InfoItem)`
  grid-area: TEMPERATURE;
`;
